import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import './AddModal.css';

const DeleteCategoryModal = ({ handleClose, show, rowData, onDelete }) => {
    const [category, setCategory] = useState([]);

    useEffect(() => {
        let array = rowData.map((item) => ({
            categoryID: item,
            deletedBy: localStorage.getItem('badgeID'),
        }));
        setCategory(array);
    }, [rowData]);

    const deleteCategory = () => {
        onDelete({
            category,
        });
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title
                    className='delete-modal-title'
                    style={{ color: '#c02d2e', marginBottom: '0px' }}
                >
                    Delete Folder
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you wish to delete this folder?
            </Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={deleteCategory}>
                    Delete Folder
                </Button>
                <Button variant='outline-secondary' onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteCategoryModal;
